import React from 'react';

import DangKiHoSoUpdate from '../../../containers/GTNS/DangKiHoSo/DangKyHoSoUpdate';

export default function DangKiHoSo() {
	return <DangKiHoSoUpdate />
}
